"use client";
import { createContext, useContext, useState, useMemo } from "react";

const AnnouncementBarContext = createContext({ isClosed: false, setIsClosed: () => {} });

export const useAnnouncementBarContext = () => useContext(AnnouncementBarContext);

const AnnouncementBarProvider = ({ children, appGenericAnnouncementBarFlagEnabled = false }) => {
  const [isClosed, setIsClosed] = useState(true);

  const value = useMemo(
    () => ({ isClosed: isClosed || !appGenericAnnouncementBarFlagEnabled, setIsClosed }),
    [isClosed, appGenericAnnouncementBarFlagEnabled],
  );

  return (
    <AnnouncementBarContext.Provider value={value}>{children}</AnnouncementBarContext.Provider>
  );
};

export default AnnouncementBarProvider;
